module.exports = __webpack_public_path__ + "static/img/big-3.416300c.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/report/design/customPage/assets/backgroundImg/big-3.png
// module id = k4Xo
// module chunks = 65